import React, { SyntheticEvent } from 'react';
import { Button } from 'antd';
import './styles.css';

type propTypes = {
  onDelete?:
    | (() => void)
    | ((e: SyntheticEvent) => void)
    | (() => Promise<void>)
    | false;
  onSave?:
    | (() => void)
    | ((e: SyntheticEvent) => void)
    | (() => Promise<void>)
    | false;
  onCancel?: (() => void) | ((e: SyntheticEvent) => void) | false;
  disabledSave?: boolean;
  show?: boolean;
  warningMsg?: boolean;
  alertMsg?: boolean;
  message?: string;
  disabledDelete?: boolean;
  styles?: any;
  saveBtnText?: string;
  buttonSaveStyles?: any;
};

const ActionButtonsBar = (props: propTypes) => {
  const {
    onDelete = false,
    onCancel = false,
    onSave = false,
    disabledSave = false,
    disabledDelete = false,
    show = true,
    warningMsg = false,
    alertMsg = false,
    message,
    styles,
    saveBtnText = 'Save',
    buttonSaveStyles,
  } = props;

  const anyActions = !onDelete && !onCancel && !onSave;
  if (anyActions || !show) return <div id="actions-buttons-empty"></div>;
  return (
    <div
      className="action-buttons-bar"
      style={{ left: window.rightContentWidth, ...styles }}
    >
      <div className="action-buttons-content">
        {onDelete && (
          <Button
            danger
            type="primary"
            onClick={onDelete}
            disabled={disabledDelete}
          >
            Delete
          </Button>
        )}
        <div className="actions-separator" />
        {alertMsg && message && <p className="warning-text">{message}</p>}
        {onCancel && <Button onClick={onCancel}>Cancel</Button>}
        {onSave && (
          <Button
            type="primary"
            onClick={onSave}
            disabled={disabledSave}
            data-test="save-btn"
            style={{ ...buttonSaveStyles }}
          >
            {saveBtnText}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ActionButtonsBar;
